import { createItem, updateItem } from 'common/api/systems';
import showToast from 'common/utils/showToast';

import {
    SAVE_ITEM,
    SAVE_ITEM_FAILURE,
    SAVE_ITEM_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

import filterItems from './filterItems';
import toggleModalProduct from './toggleModalProduct';

export default (filterData, values) => (dispatch) => {
    let newValues = {
        country: values.country,
        custom_offer_template_bom: values.template_bom,
        name: values.name,
        type_application: values.type_application,
        uniqueid: values.name,
    };

    let products = [];

    if (values.products.length) {
        for (let i = 0; i < values.products.length; i++) {
            if (values.products[i].item) {
                products.push(values.products[i].item);
            }
        }

        if (products.length) {
            newValues.products = products;
        }
    }

    if (values.template_system) {
        newValues.custom_offer_template_system = values.template_system;
    }

    dispatch(actions[SAVE_ITEM]());

    const save = values.id
        ? () => updateItem(newValues, values.id)
        : () => createItem(newValues);

    save()
        .then(() => {
            dispatch(actions[SAVE_ITEM_SUCCESS]());
            dispatch(filterItems(filterData));
            dispatch(toggleModalProduct(false));
            showToast();
        })
        .catch((error) =>
            dispatch(actions[SAVE_ITEM_FAILURE](error?.response?.data?.errors)),
        );
};
